export const ROW_SIZE_PIXELS = 36;
export const OVERSCAN_COUNT = 5;
export const SIGN_WIDTH_PIXELS = 9;
export const MIN_LIST_WIDTH_PIXELS = 200;
export const MAX_LIST_HEIGHT_PIXELS = 200;
export const MOCK_OPTIONS = [
    {
        label: 'Harley Davidson',
        value: 'harley_davidson',
    },
    {
        label: 'Honda',
        value: 'honda',
    },
    {
        label: 'Yamaha',
        value: 'yamaha',
    },
    {
        label: 'Triumph',
        value: 'triumph',
    },
    {
        label: 'Kawasaki',
        value: 'kawasaki',
    },
    {
        label: 'Suzuki',
        value: 'suzuki',
    },
    {
        label: 'Ducati',
        value: 'ducati',
    },
    {
        label: 'BMW',
        value: 'bmw',
    },
];
//# sourceMappingURL=AggregateDropdown.constants.js.map